// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dropdown-link {\n  cursor: pointer;\n  color: #409EFF;\n  font-size: 12px;\n  font-weight: 500;\n}\n.el-icon-arrow-down {\n  font-size: 12px;\n}\n\n", ""]);
// Exports
module.exports = exports;
